import { Heading } from '@chakra-ui/react'
import { Layout } from 'components/atoms'
import { InputBuild } from 'components/molecules'
import React from 'react'
import { useFormContext } from 'react-hook-form'
import { DataForm } from './form'
import { DataFormProps } from './interfaces'
import { DataKeys } from './types'

const Data: React.FC = () => {
    const {
        register,
        watch,
        formState: { errors }
    } = useFormContext<{ data: DataFormProps }>()

    const hasError = (id: DataKeys) => {
        return errors.data && errors.data[id]
    }

    return (
        <Layout type="container" px={8}>
            <Layout type="row">
                <Heading size="md" textAlign={{ sm: 'center' }}>
                    Dados da instituição financeira
                </Heading>
            </Layout>
            <Layout type="row" gutter={{ y: 1.5 }}>
                {DataForm.map(({ layout, input }, key) => (
                    <Layout {...layout} key={key}>
                        <InputBuild
                            {...input}
                            err={hasError(input.id)}
                            {...register(`data.${input.id}`)}
                            value={watch(`data.${input.id}`) as string}
                        ></InputBuild>
                    </Layout>
                ))}
            </Layout>
        </Layout>
    )
}

export default Data
